import React from 'react';
import { StaticPageHeader } from '../components/StaticPageHeader';
import { Footer } from '../components/Footer';

export const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-white">
      <StaticPageHeader />

      {/* Add padding top to account for fixed header */}
      <div className="pt-16">
        {/* Content */}
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Terms of Service</h1>
          <p className="text-gray-600 mb-8">Effective Date: July 1, 2026</p>

          <div className="prose prose-lg max-w-none">
            <p className="text-gray-700 mb-6">
              By accessing or using the DriveHR website (&quot;Site&quot;) and services, you agree to these Terms of Service.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. Use of Site and Services</h2>
            <p className="text-gray-700 mb-6">
              You may access and use our templates, guides, and digital products for internal business purposes only. Redistribution or resale is prohibited.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Account &amp; One-Time Purchases</h2>
            <p className="text-gray-700 mb-6">
              You agree to provide accurate information when creating an account or making a purchase. One-time template and bundle purchases are delivered digitally and, because of their nature, all one-time digital product sales are final and non-refundable once the download has been made available.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Memberships, Billing &amp; Cancellation</h2>
            <p className="text-gray-700 mb-6">
              Memberships are billed on a recurring monthly basis to your payment method on file. By subscribing, you authorize DriveHR (via Stripe) to automatically charge your membership fee each month until you cancel. You may cancel at any time from your account billing portal or by emailing <a href="mailto:help@drive-hr.com" className="text-blue-600 hover:underline">help@drive-hr.com</a>. Cancellation stops future charges; your access continues through the end of the current paid billing period. Membership fees are non-refundable, including for partial billing periods, except where required by law. We will provide notice of any price changes before they take effect.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Acceptable Use &amp; License</h2>
            <p className="text-gray-700 mb-6">
              Subject to these Terms, DriveHR grants you a limited, non-exclusive, non-transferable license to use our templates, guides, and digital products for your own internal business purposes only. You may not resell, redistribute, sublicense, publish, or share our materials with third parties, or use them to create a competing product. This license ends if your membership ends, though templates you downloaded during an active membership remain yours to use internally.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Intellectual Property</h2>
            <p className="text-gray-700 mb-6">
              All content on the Site is owned by DriveHR and protected under copyright law. You may not reproduce, republish, or distribute any materials without our written permission.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">6. No Legal Advice</h2>
            <p className="text-gray-700 mb-6">
              DriveHR is not a law firm and does not provide legal advice. Our content is for informational use only. Always consult your attorney before implementing policies.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">7. Disclaimers &amp; Limitation of Liability</h2>
            <p className="text-gray-700 mb-6">
              Our Site, products, and services are provided &quot;as is&quot; and &quot;as available&quot; without warranties of any kind, express or implied, including fitness for a particular purpose. To the fullest extent permitted by law, DriveHR and its owners shall not be liable for any indirect, incidental, or consequential damages, or for any actions taken or not taken based on our materials. Our total liability for any claim shall not exceed the amount you paid us in the twelve (12) months preceding the claim.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">8. Governing Law</h2>
            <p className="text-gray-700 mb-6">
              These Terms are governed by the laws of the State of Connecticut, without regard to its conflict-of-laws principles. Any disputes shall be resolved in the state or federal courts located in Connecticut.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">9. Modifications</h2>
            <p className="text-gray-700 mb-6">
              We reserve the right to modify these terms at any time. Continued use of the Site indicates acceptance.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">10. Contact</h2>
            <p className="text-gray-700 mb-6">
              For questions, email <a href="mailto:help@drive-hr.com" className="text-blue-600 hover:underline">help@drive-hr.com</a>.
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};
